// removed by extract-text-webpack-plugin
module.exports = {"container":"dosage-chart__container___3TPDj","headerContainer":"dosage-chart__headerContainer___3oh3D","header":"dosage-chart__header___1JukF"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/prescription/dosage-chart.css
// module id = 1179
// module chunks = 0